import { Button, FlexItem, Flex, Text } from '@patternfly/react-core';
import React, { useCallback, useMemo } from 'react';
import useBoolean from '../../utils/hooks/useBoolean';
import TreeSelectionModal from '../TreeSelection/TreeSelectionModal';
import { useTranslation } from '../../localization/useTranslation';
import _ from 'lodash';

const NodeSelection = ({ selections, onSelectionChanged, allowNodes, allowAssets, allowTypeChange }) => {
  const T = useTranslation();

  const [nodeSelectionVisible, showNodeSelection, hideNodeSelection] = useBoolean(false);

  const onSelection = useCallback(newSelection => {
    hideNodeSelection();
    onSelectionChanged(newSelection);
  }, [hideNodeSelection, onSelectionChanged]);

  const nodeNames = useMemo(() => {
    if (_.isEmpty(selections)) {
      return T.common.input.nodes.relativenode;
    }
    if (_.size(selections) > 1) {
      return T.common.input.nodes.twoormoreselected;
    }
    return selections[0].displayName;
  }, [T.common.input.nodes.relativenode, T.common.input.nodes.twoormoreselected, selections]);

  return (
    <>
      <Flex>
        <FlexItem>
          <Button onClick={showNodeSelection} >{ T.common.input.nodes.selectmultiple }</Button>
        </FlexItem>
        <FlexItem>
          <Text>{ nodeNames }</Text>
        </FlexItem>
      </Flex>
      <TreeSelectionModal
        selections={selections}
        isOpen={nodeSelectionVisible}
        onConfirm={onSelection}
        onCancel={hideNodeSelection}
        allowAssets={allowAssets}
        allowNodes={allowNodes}
        allowSelectionChange={allowTypeChange}
      />
    </>
  );
};

export default React.memo(NodeSelection);
